import initChart from './init_chart.js'
import updateBars from './update_bars.js'

riot.tag2('history-chart', '', '', 'class="history-chart"', function(opts) {

  this.on('mount', () => {
    this.opts.element = this.root
    this.chartOpts = initChart(this.opts)
  })

  this.on('update', () => {
    if (this.chartOpts) updateBars(this.chartOpts, this.opts.data)
  })

});



// WEBPACK FOOTER //
// ./src/components/station-infobox/history-chart.tag